import { InfoCard, InfoGrid, InfoSection } from '../diagnostics/InfoSection';

interface MetadataTabProps {
  evalPrompt?: any;
  modelConfig?: any;
  executionTimeMs?: number;
  tokenUsage?: any;
  createdAt: string;
}

export function MetadataTab({
  evalPrompt,
  modelConfig,
  executionTimeMs,
  tokenUsage,
  createdAt,
}: MetadataTabProps) {
  return (
    <div style={{ display: 'grid', gap: '1.5rem' }}>
      {/* Prompt */}
      <InfoSection title="Prompt">
        <InfoCard>
          <div style={{ fontWeight: 500, marginBottom: '0.5rem' }}>
            {evalPrompt?.name}
          </div>
          <div
            style={{
              fontSize: '0.875rem',
              color: '#8B7764',
              whiteSpace: 'pre-wrap',
            }}
          >
            {evalPrompt?.text}
          </div>
        </InfoCard>
      </InfoSection>

      {/* Config */}
      <InfoSection title="Model Configuration">
        <InfoCard>
          <InfoGrid
            items={[
              { label: 'Name', value: modelConfig?.name },
              { label: 'Provider', value: modelConfig?.provider },
              { label: 'Model', value: modelConfig?.api_model },
              {
                label: 'Temperature',
                value: modelConfig?.temperature ?? 'default',
              },
              {
                label: 'Max Tokens',
                value: modelConfig?.max_tokens ?? 'default',
              },
            ]}
          />
        </InfoCard>
      </InfoSection>

      {/* Execution Stats */}
      <InfoSection title="Execution Stats">
        <InfoCard>
          <InfoGrid
            items={[
              {
                label: 'Execution Time',
                value: executionTimeMs ? `${executionTimeMs}ms` : undefined,
              },
              { label: 'Tokens (Input)', value: tokenUsage?.input },
              { label: 'Tokens (Output)', value: tokenUsage?.output },
              { label: 'Created', value: new Date(createdAt).toLocaleString() },
            ]}
          />
        </InfoCard>
      </InfoSection>
    </div>
  );
}
